import { createComponent } from '@front/utils/alpine';
import { getBreakpoint, setListener } from '@front/utils';

export default createComponent(() => ({
    isOpen: false ,
    isRegister: false,
    isPassword: false,
    scrollLock: false,

    init() {
        const inputs : NodeListOf<HTMLInputElement> = document.querySelectorAll('.js-account-sidebar-input');

        if (inputs.length) {
            inputs.forEach((item) => {
                setListener(item, 'focus', () => {
                    this.scrollLock = true;
                });
    
                setListener(item, 'blur', () => {
                    this.scrollLock = false;
                });
            });
    
            document.addEventListener('scroll', () => {
                this.scrollLock && getBreakpoint('lg') > window.innerWidth ? document.documentElement.scrollTop = 0 : '';
            });
        }
    },
}));